import { render, staticRenderFns } from "./packageRules.vue?vue&type=template&id=892d9a22&scoped=true"
import script from "./packageRules.vue?vue&type=script&lang=js"
export * from "./packageRules.vue?vue&type=script&lang=js"
import style0 from "./packageRules.vue?vue&type=style&index=0&id=892d9a22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892d9a22",
  null
  
)

export default component.exports